import { setStorageItem } from '../../../../../utils/storage'
import { NEWSBOARD_POST_HIDE_WELCOME_POST_STORAGE_NAME } from '../../../Newsboard.constants'

export function hidePost() {
  setStorageItem(NEWSBOARD_POST_HIDE_WELCOME_POST_STORAGE_NAME, true)
}
